import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

// helper
import { BaseError } from '../../helpers/BaseError';

// API
import API from '../../services/api';

import useGetCurrentMessageContent from '../message-content/useGetCurrentMessageContent';
import formulaKeys from './_queryKeys';

export default function useFormulaTimeSlotsMutation(formulaId?: number) {
    const queryClient = useQueryClient();
    const { currentMessageContentId } = useGetCurrentMessageContent(formulaId);
    return useMutation<
        AxiosResponse<string>,
        BaseError,
        { time_slot_ids: string[] }
    >({
        mutationFn: (data: { time_slot_ids: string[] }) =>
            API.updateFormulaTimeSlots({ formulaId, data }),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.approvedFormulaById(
                    formulaId!,
                    currentMessageContentId,
                ),
            });
        },
    });
}
